<template>
  <v-dialog v-model="dialog" persistent max-width="380" content-class="max-zindex">
    <v-card>
      <v-card-title class="headline">提示</v-card-title>
      <v-card-text class="d-flex align-center">
        <v-icon color="warning" size="48" class="mr-3">{{ icons.mdiHelpCircle }}</v-icon>
        <div>
          <div>此预定为
            <a target="_blank" href='https://support-places.accenture.com/places'>Places</a>

            网站申请，请前往取消
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#b133ff" small dark @click.native="$emit('confirmed')">确认</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {
  mdiHelpCircle,
} from '@mdi/js'
import moment from 'moment'

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    room: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      icons: {
        mdiHelpCircle,
      },
    }
  },
}
</script>
